import PolicyLayout, { Section } from "@/components/PolicyLayout";

export default function PrivacyPage() {
  return (
    <PolicyLayout
      testId="privacy-page"
      eyebrow="Legal"
      title="PRIVACY POLICY"
      subtitle="How JPA collects, uses and safeguards your personal information."
      effective="1 February 2026"
    >
      <Section title="1. Information we collect">
        <p>When you register as a player, club or referee we collect: full name, email, phone number, date of birth, gender, district, profile photo, Aadhaar images (for verification only), optional DUPR &amp; PGID identifiers, and — for clubs — court photos and address.</p>
        <p>We also collect operational data: tournament entries, match results, payment receipts uploaded by you, and browser/device metadata (IP, user agent) for security logs.</p>
      </Section>

      <Section title="2. How we use your data">
        <p>We use your information to run the JPA services — issuing your JPA ID and player card, publishing rankings, running tournaments, sending approval / entry notifications on WhatsApp and email, and complying with AIPA affiliation requirements. We do not sell or rent your personal data to any third party.</p>
      </Section>

      <Section title="3. Aadhaar &amp; sensitive documents">
        <p>Aadhaar images are visible only to JPA administrators during verification. When you leave the &quot;Auto-delete Aadhaar files after approval&quot; option enabled (recommended), your Aadhaar images are permanently removed from our servers immediately after your account is approved.</p>
      </Section>

      <Section title="4. Public information">
        <p>Once approved, your name, JPA ID, district, gender, profile photo, DUPR ID (if provided) and your ranking points / tournament results become publicly visible on your player profile so that other players and tournament organizers can identify you. Contact details (email, phone) remain private.</p>
      </Section>

      <Section title="5. Cookies &amp; sessions">
        <p>We use HTTP-only session cookies for authentication and to keep you signed in. We do not use third-party advertising cookies. Analytics, if enabled in the future, will use anonymised aggregate data.</p>
      </Section>

      <Section title="6. Data retention">
        <p>Approved-player data is retained for as long as your account exists. Rejected or self-deleted registrations are purged within 30 days. Aadhaar images are deleted per §3 above. Tournament results are retained indefinitely for historical rankings.</p>
      </Section>

      <Section title="7. Your rights">
        <p>You can request a copy of your data, correct inaccuracies, or ask us to delete your account by writing to <b>info@jpaofficial.com</b>. Deletion requests are actioned within 15 working days, except where retention is required by law or for on-going tournament administration.</p>
      </Section>

      <Section title="8. Security">
        <p>We store passwords using bcrypt hashing, use HTTPS for all traffic, and restrict Aadhaar and payment images to authenticated admin sessions. However, no online service can guarantee absolute security — please protect your password and log out on shared devices.</p>
      </Section>

      <Section title="9. Third-party services">
        <p>We may share limited data with the following processors: MongoDB (database hosting), WhatsApp (for approval notifications), and — in the future — payment gateways for tournament fees. Each processor is bound by its own privacy commitments.</p>
      </Section>

      <Section title="10. Contact">
        <p>For any privacy queries, write to <b>info@jpaofficial.com</b> or call <b>+91 93047 57995</b>. Postal: 3-S Geeta Colony, Latma Road, Singh More, Ranchi, Jharkhand 834003.</p>
      </Section>
    </PolicyLayout>
  );
}
